import { jsonApi } from '../http-request';

export const actions = jsonApi.createUpdResourceFacade('items');
